"use client";
import { Button } from "@/components/ui/button";
import Image from "next/image";
import Link from "next/link";
import { ArrowRight } from "lucide-react";

type HomeProps = {
  content: {
    heroTitle: string;
    heroDescriptions: string;
    heroImage: any; 
    imageWidth?: number;
  };
};

export default function Hero({ content }: HomeProps) {
  const {
    heroTitle,
    heroDescriptions,
    heroImage,
    imageWidth = 602, 
  } = content;

  return (
    <div className="container mx-auto">
      <div className="grid grid-cols-2 pt-30 pb-10">
        <div className="flex flex-col gap-8 max-w-[509px]">
          <div className="flex">
            <h1 className="text-[54px]/18 font-medium">
              {heroTitle}
            </h1>
          </div>
          <div className="flex text-[20px] w-[90%]">
            <span>{heroDescriptions}</span>
          </div>
          <div className="flex gap-4">
            <Button
              asChild
              className="rounded-3xl bg-[#4381E5] hover:bg-transparent 
              hover:text-[#4381E5] hover:border-[#4381E5] hover:border-1 font-semibold text-[14px] w-[247px] h-[48px]"
            >
              <Link href="#" className="!text-base">
                Start order
              </Link>
            </Button>
            <Button
              variant="outline"
              className="rounded-3xl border-[#4381E5] text-[#4381E5]
              hover:bg-[#4381E5] hover:text-white h-[48px] w-[153px] bg-transparent"
            >
              <Link href="#" className="!text-base">
                Get a quote
              </Link>
            </Button>
          </div>
        </div>
        <div className="flex justify-end -ml-9 text-[#1B1F3B] relative h-[516px]" style={{ width: imageWidth ?? 602 }}>
          <div className="absolute top-[-10%] left-[0%]">
            <Image
              alt="hero image"
              src={heroImage}
              width={0}
              height={0}
              className="w-full h-full"
              quality={100}
              priority
            />
          </div>
        </div>
      </div>
    </div>
  );
}